import React, { useEffect, useState } from "react";
import { fetchSingleSubCategory } from "../services/operations/admin";
import { Link, useParams } from "react-router-dom";
import Navbar from "../components/comman/Navbar";
import Seo from "../components/comman/Seo";
import { getOptimizedImageUrl, SITE_NAME } from "../constant/site";

function SubCategorySingle() {
  const { id } = useParams();
  const [news, setNews] = useState([]);
  const [related, setRelated] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchNews = async (subCategoryId) => {
      setLoading(true);
      try {
        const response = await fetchSingleSubCategory(subCategoryId);
        setNews(response.subCategories);
        setRelated(response.randomCategories);
      } catch (error) {
        console.error("Error fetching news:", error);
      }
      setLoading(false);
    };
    fetchNews(id);
  }, [id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const subCategoryName = news?.name || "Subcategory";
  const subCategoryDescription =
    news?.description || `Latest ${subCategoryName} news updates from ${SITE_NAME}.`;

  return (
    <div>
      <Seo
        title={`${subCategoryName} News`}
        description={subCategoryDescription}
        keywords={[subCategoryName, "latest news", SITE_NAME]}
        url={`/subcategory/${id}`}
      />
      <Navbar />

      {loading || !news ? (
        <div className="grid min-h-[calc(100vh-3.5rem)] place-items-center">
          <div className="spinner"></div>
        </div>
      ) : (
        <>
          <div className="w-screen mt-[120px]">
            <div className="w-[90%] mx-auto">
              <h3 className="text-xl font-semibold mb-2">{news.name}</h3>
              <h4 className="text-md font-light mb-4">{news.description}</h4>
            </div>
          </div>

          <div className="flex flex-col lg:flex-row p-4 gap-4">
            <div className="w-full lg:w-7/12">
              {news && (
                <div className="bg-white shadow-md rounded-lg p-4 mb-4">
                  {news?.news?.map((newsItem) => (
                    <div key={newsItem._id} className="mt-4">
                      <Link
                        to={`/${newsItem?.slug}`}
                        className="text-lg font-semibold mb-2 text-blue-600 underline"
                      >
                        {newsItem.title}
                      </Link>
                      <img
                        src={getOptimizedImageUrl(newsItem?.images[0]?.url)}
                        alt={newsItem?.title || ""}
                        className="w-[60%]"
                      loading="lazy"
                        decoding="async"
                      />
                      <h4 className="text-md font-light mb-4">
                        {newsItem.subtitle}
                      </h4>
                      <p className="text-gray-700 mb-4">{newsItem.location}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <div className="w-full lg:w-5/12 top-10">
              <div className="bg-blue-500 p-2 text-white">
                <h3>Related News</h3>
              </div>
              <div className="flex flex-col gap-3 mt-8 p-2">
                {related?.map((currElem) =>
                  currElem.news.map((newsItem) => (
                    <Link
                      to={`/${newsItem?.slug}`}
                      key={newsItem._id}
                      className="flex gap-3 items-center bg-white shadow-md p-2 rounded-lg"
                    >
                      <img
                        src={getOptimizedImageUrl(newsItem?.images[0]?.url)}
                        alt={newsItem.title}
                        className="w-24 h-auto rounded-lg"
                      loading="lazy"
                        decoding="async"
                      />
                      <p className="text-wrap mt-2 text-sm">{newsItem.title}</p>
                    </Link>
                  ))
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default SubCategorySingle;